import {
  Kbd as ChakraKbd,
  KbdProps as ChakraKbdProps,
  forwardRef,
} from '@chakra-ui/react';
import React from 'react';

import { OmitChakraProps } from '../../utils/typeUtils';

export interface KbdProps extends OmitChakraProps<ChakraKbdProps, 'children'> {
  text: string;
}

export const Kbd = forwardRef<KbdProps, 'kbd'>(({ text, ...props }, ref) => {
  return (
    <ChakraKbd {...props} ref={ref}>
      {text}
    </ChakraKbd>
  );
});
